import { createContext, useState, useContext } from 'react';

const PdfContext = createContext<any>(null);

export const PdfProvider = ({ children }: any) => {
  const [downloadPdf, setDownloadPdf] = useState<boolean>(false);

  return (
    <PdfContext.Provider value={{ downloadPdf, setDownloadPdf }}>
      {children}
    </PdfContext.Provider>
  );
};

export const useDownloadPdf = () => useContext(PdfContext);
